module.exports = __webpack_public_path__ + "assets/chevron-right-sharp.44698d68.svg";